import { useCallback, useEffect, useState } from 'react';
import { EmployeeLoanService } from '../services/employeeLoan.service';
import { ILoanOpeningBalancePreview } from '../interfaces/employeeLoan.interface';

export interface LoanAccounting {
    /** True while unknown or on a failed read, so the account pickers never vanish by mistake. */
    accountingOn: boolean;
    /** Loans paid out while Accounting was off and not yet in the books (null until loaded). */
    preview: ILoanOpeningBalancePreview | null;
    reload: () => void;
}

/**
 * Whether loans post journals for this institution. Without the Accounting module, loans and
 * advances are a plain register: no account pickers, no journal entries. The backend answers
 * (same fail-open rule as the module switch), so the screen and the server never disagree.
 */
export const useLoanAccounting = (institutionId: string | null | undefined): LoanAccounting => {
    const [preview, setPreview] = useState<ILoanOpeningBalancePreview | null>(null);
    const [tick, setTick] = useState(0);

    useEffect(() => {
        if (!institutionId) {
            setPreview(null);
            return;
        }
        let alive = true;
        EmployeeLoanService.openingBalancePreview(institutionId)
            .then(p => { if (alive) setPreview(p); })
            .catch(() => { if (alive) setPreview(null); });
        return () => { alive = false; };
    }, [institutionId, tick]);

    const reload = useCallback(() => setTick(t => t + 1), []);
    return { accountingOn: preview ? preview.accountingOn : true, preview, reload };
};
